import { select } from '../@tix02/utility/dom';
import OverlayPanel from '../@tix02/component/OverlayPanel';


const config = {
	OPEN_HANDLER: '.search-toggle',
	CLOSE_HANDLER: '#searchform-close',
	ACTIVE_BODY_CLASSNAME: 'search-form-shown',
};


/*
 * D 
 */
export default () => {
	const element = select('.app-search').first;
	if(! element ) {
		return;
	}
	
	const panel = new OverlayPanel(element, config); 
	const control = select('#s').first;
	if( control ) {
		panel.addEventListener('onOpen', () => {
			control.focus();
		});
	}
};

